import React from 'react'
import closeIcon from '../../../images/close_icon.svg'
import PropTypes from 'prop-types'

const Modal = ({ children, hideModal }) => (
  <div className='fixed top-0 left-0 h-full w-full bg-black/50 z-30'>
    <div className='absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 scrollbar overflow-y-scroll bg-white rounded-2xl h-5/6 pb-20 drop-shadow-2xl'>
      <div
        className='flex justify-end sticky top-0 z-40'
        onClick={hideModal}
      >
        <img
          src={closeIcon}
          alt='Close icon'
          className='cursor-pointer m-5 '
        />
      </div>
      {children}
    </div>
  </div>
)

export default Modal

Modal.propTypes = {
  children: PropTypes.node.isRequired,
  hideModal: PropTypes.func.isRequired
}
